import 'css-chunk:src/app/containers/Projects/ProjectsPage/GroupContentReviewPage/ContentReviewPanel.scss';export default {
  "ContentReviewPanel": "_ContentReviewPanel_r8g0s_1",
  "title": "_title_r8g0s_1",
  "icon": "_icon_r8g0s_8",
  "svg": "_svg_r8g0s_21"
};